<table role="grid">
  {{#if sr_description}}
  <caption style="font-size: 0; padding: 0;">{{t sr_description}}</caption>
  {{/if}} 

  {{#each rows}} 
    {{#if @first}}

      {{#if header}}
        <tr class="{{class}}" data-row="{{@index}}">
          {{#each cells}}
          <th scope="col" id="{{id}}" class="{{class}}" data-column="{{@index}}" data-row="{{@../index}}" {{#if colspan}}colspan="{{colspan}}" {{/if}} {{#if rowspan}}rowspan="{{rowspan}}" {{/if}}>
            {{#if description}}
              <div class="description">{{t description}}</div>
            {{/if}} 
            {{#if blocks}}
              <div data-region="{{../../cid}}-cell-{{@index}}-row-{{@../index}}-blocks"></div>
            {{/if}}
          </th>
          {{/each}}
        </tr>
      {{else}}
        <tr class="{{class}}" data-row="{{@index}}">
          {{#each cells}}
          <td headers="{{headers}}" {{#if header}} id="{{id}}" {{/if}} class="{{class}}" data-column="{{@index}}" data-row="{{@../index}}" {{#if colspan}}colspan="{{colspan}}" {{/if}} {{#if rowspan}}rowspan="{{rowspan}}" {{/if}}>
            {{#if description}}
            <div class="description">{{t description}}</div>
            {{/if}} {{#if blocks}}
            <div data-region="{{../../cid}}-cell-{{@index}}-row-{{@../index}}-blocks"></div>
            {{/if}}
          </td>
          {{/each}}
        </tr>
      {{/if}}

    {{else}}
    
        <tr class="{{class}}" data-row="{{@index}}">
            {{#each cells}}

              {{#if header}}
                <td {{#if @first}}scope="row" id="{{id}}"{{else}} headers="{{headers}}"{{/if}} class="{{class}}" data-column="{{@index}}" data-row="{{@../index}}" {{#if colspan}}colspan="{{colspan}}" {{/if}} {{#if rowspan}}rowspan="{{rowspan}}" {{/if}}>
              {{else}}
                <td headers="{{headers}}" class="{{class}}" data-column="{{@index}}" data-row="{{@../index}}" {{#if colspan}}colspan="{{colspan}}" {{/if}} {{#if rowspan}}rowspan="{{rowspan}}" {{/if}}>
              {{/if}}
                  {{#if description}}
                    <div class="description">{{t description}}</div>
                  {{/if}} 
                  {{#if blocks}}
                    <div data-region="{{../../cid}}-cell-{{@index}}-row-{{@../index}}-blocks"></div>
                  {{/if}}
                </td>

            {{/each}}
        </tr>


    {{/if}}
  {{/each}}
<table>